export function getChildrenClassForNestedItems(parent, childrenTagName = "ul", childrenClass = "hasChildren") {
    let hasChildren = false;
    let childrenLink = false;
    for (const children of parent.children) {
        if (children.tagName === childrenTagName.toUpperCase()) {
            hasChildren = true;
        }
        if (children.tagName === 'A' || children.tagName === 'SPAN') {
            childrenLink = children;
        }
    }

    if (hasChildren) {
        const triggerOpener = document.createElement("span");
        triggerOpener.classList.add("navChildrenToggle");
        childrenLink.appendChild(triggerOpener);

        const toggleMenu = function (e) {
            const closestLi = triggerOpener.closest('li');
            if (closestLi.classList.contains("open")) {
                closestLi.classList.remove("open");
                triggerOpener.classList.remove("is-active");
            } else {
                closestLi.classList.add("open");
                triggerOpener.classList.add("is-active");
            }
            e.preventDefault();
            e.stopPropagation();
        };

        triggerOpener.addEventListener("click", toggleMenu);

        if (childrenLink.tagName === 'SPAN') {
            childrenLink.classList.add("clickable-parent");
            childrenLink.addEventListener("click", toggleMenu);
        }

        parent.classList.add(childrenClass);
    }
}